<template lang="pug">
  .scroller.js-scroller(ref='main')
    .scroller__heading(ref='header')
      div(ref='title').scroller__padder
        h2.app__title.app__title--nostyle.bged: slot(name='title') {{ title }}
      div(ref='image').scroller__padder
        slot(name='header')
        
        

    .scroller__content(ref='scroller')
      slot(name='content')
      //- img.scroller__img.scroller__img--static(:src='currImage.content || currImageComp.content' ref='content')
      //- hr
      //- img.scroller__img.scroller__img--static(:src='currImage.content || currImageComp.content')
</template>

<script>
export default {
  watch: {
    width(val) {
      const breakpoint = 960;
      return (this.currImage = {
        header: window.innerWidth >= breakpoint ? "" : this.header["320"],
        content:
          window.innerWidth >= breakpoint
            ? this.content[breakpoint]
            : this.content["320"]
      });
    },
    event(val) {
      this.event = val;
    }
  },
  inject: [
    'preloaderService'
  ],
  computed: {
    currImageComp() {
      const breakpoint = 960;
      return {
        header: window.innerWidth >= breakpoint ? "" : this.headerImage320,
        content:
          window.innerWidth >= breakpoint
            ? this.contentImage960
            : this.contentImage320
      };
    }
  },
  watch: {},
  data() {
    return {
      headerAttrs: {},
      currImage: {},
      width: window.innerWidth,
      lastScroll: 0,
      titleVisible: true,
      event: "",
      poser: {},
      elements: [],
      top: 0,
      ready: false
    };
  },
  props: {
    title: {
      type: String,
      // required: false
    },
    headerImage320: {
      type: String,
      // required: true
    },
    contentImage320: {
      type: String,
      // required: true
    },
    contentImage960: {
      type: String,
      // required: true
    }
  },
  watch: {},
  created() {
    this.preloaderService.setLoading()
  },
  mounted() {
    let width = window.innerWidth
    window.addEventListener("DOMContentLoaded", () => {
      window.addEventListener("scroll", this.scroll);
      window.addEventListener("resize", () => {
        if(window.innerWidth != width) {
          location.reload()

        }
        this.scroll()
      })
      this.preloaderService.unsetLoading()
    })
    this.elements = {
      header: this.$refs.header,
      titleWrapper: this.$refs.title,
      imageWrapper: this.$refs.image
    };
    if(window.innerWidth < 960) {
      let height = $(".app__header").innerHeight();
      $(".app__container").css("padding-top", `${height}px`)
      // this.$refs.main.style.paddingTop = height + "px";
    }
  },
  methods: {
    getOffsetTop(elem) {
      let offsetTop = 0;
      do {
        if (!isNaN(elem.offsetTop)) {
          offsetTop += elem.offsetTop;
        }
      } while ((elem = elem.offsetParent));
      return offsetTop;
    },
    accumulate(el) {
      return el.clientHeight;
    },
    scroll() {
      let bottom =
        this.$refs.scroller.clientHeight + this.$refs.scroller.offsetTop;
      if (window.innerWidth < 960) {
        let height = $(".app__header").innerHeight();
        let st = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
        let imageWrapper = this.elements.imageWrapper;
        let titleWrapper = this.elements.titleWrapper;
        if (st > this.lastScroll) {
          $(".app__header").css("position", "absolute");
          if (
            st > this.getOffsetTop(imageWrapper) &&
            st < this.$refs.scroller.scrollHeight + 20
          ) {
            this.handlePadding(imageWrapper, "fixed", 0);
            this.handlePadding(titleWrapper, 'static', 50)
          } else if (st >= this.$refs.scroller.offsetTop  + this.$refs.scroller.scrollHeight - imageWrapper.childNodes[0].clientHeight + 140) {
            // console.log(st, this.$refs.scroller.offsetTop  + this.$refs.scroller.scrollHeight - imageWrapper.childNodes[0].clientHeight + 140)
            this.handlePadding(titleWrapper,
                               "absolute",
                               this.$refs.scroller.offsetTop + this.$refs.scroller.clientHeight - imageWrapper.childNodes[0].clientHeight * 2);
            
            this.handlePadding(
              imageWrapper,
              "absolute",
              this.$refs.scroller.offsetTop + this.$refs.scroller.clientHeight - imageWrapper.childNodes[0].clientHeight * 2
              //  - imageWrapper.childNodes[0].clientHeight * 2
            );
          }
          if (
            st < this.getOffsetTop(imageWrapper)
          ) {
            this.handlePadding(titleWrapper, 'static', 0)
            this.handlePadding(imageWrapper, "static", 0);
          }
        } else if (st <= this.lastScroll) {
          $(".app__header").css("position", "fixed");
          let elements = [imageWrapper, titleWrapper, $(".app__header")[0]];
          // console.log(st <= this.$refs.main.offsetTop)
          if (st <= this.$refs.main.offsetTop) {
            // console.log(st, this.$refs.main.offsetTop)
            this.handlePadding(imageWrapper, "static", 0, true);
            this.handlePadding(titleWrapper, "static", 0, true);
            return 
          }
          // if (st <= this.$refs.scroller.offsetTop + this.$refs.scroller.scrollHeight - imageWrapper.clientHeight * 2 - 40 + titleWrapper.clientHeight) {
          if (st <= this.$refs.scroller.offsetTop + this.$refs.scroller.scrollHeight - imageWrapper.clientHeight + 100) {
            console.log(st, this.$refs.scroller.offsetTop + this.$refs.scroller.scrollHeight - imageWrapper.clientHeight * 2 + titleWrapper.clientHeight)
            this.handlePadding(titleWrapper, "fixed", this.accumulate($('.app__header')[0]), true);            
          }
          // if (st <= this.$refs.scroller.offsetTop + this.$refs.scroller.scrollHeight - imageWrapper.clientHeight * 2 - 40) {
          if (st <= this.$refs.scroller.offsetTop + this.$refs.scroller.scrollHeight - imageWrapper.clientHeight * 2 + 20 + titleWrapper.clientHeight) {
            this.handlePadding(imageWrapper, "fixed", this.accumulate(titleWrapper) + this.accumulate($('.app__header')[0]), true);
          }
          // if (st > this.$refs.scroller.scrollHeight) {
          //   console.log("yes")
          //   this.handlePadding(titleWrapper, "static", 0);
          //   // this.accumulate(elements)
          // }
        }
        this.lastScroll = st;
      } else {
        // content.style.paddingTop = 0
      }
    },
    handlePadding(element, type, position, both) {
      this.elements.titleWrapper.style.width = this.elements.imageWrapper.childNodes[0].clientWidth + 'px'
      let child = element.childNodes[0];      
      let height = child.clientHeight;
      let width = child.clientWidth;
      element.style.height = height + "px";
      element.style.width = width + "px";
      child.style.height = height + "px";
      child.style.width = width + "px";
      // console.log(element, type, position, both)
      if (type != "static") {
        child.style.transform = "translateX(-50%)";
        child.style.top = position + "px";
      } else {
        child.style.transform = "translateX(-0%)";
        child.style.left = "0%";
        child.style.position = type;
        return
      }
      if (both && type != "static") {
        child.style.transform = "translateX(-50%)";
      }
      child.style.left = "50%";
      child.style.position = type;
    }
  },
  beforeDestroy() {
    document.removeEventListener("DOMContentLoaded", () => {}, false);
    document.removeEventListener("scroll", this.scroll, false);
    document.removeEventListener("resize", this.scroll, false);
  }
};
</script>




// WEBPACK FOOTER //
// src/js/shared/components/scrolling-table.vue